import React, {useEffect, useState} from 'react';
import api from '../api/axiosInstance';
import {Button} from '../components/Button';
import BundledProductFormModal from '../components/BundledProductFormModal';

export default function AdminBundledProductManager() {
    const [bundles, setBundles] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [modalOpen, setModalOpen] = useState(false);
    const [editingBundle, setEditingBundle] = useState(null);

    useEffect(() => {
        fetchBundles(currentPage);
    }, [currentPage]);

    const fetchBundles = async (page = 1) => {
        const res = await api.get(`/admin/products/bundled?page=${page}`);
        setBundles(res.data.products);
        setTotalPages(res.data.pageCount);
    };

    const openCreateModal = () => {
        setEditingBundle(null);
        setModalOpen(true);
    };

    const openEditModal = (bundle) => {
        setEditingBundle(bundle);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setEditingBundle(null);
    };

    const handleSave = async (bundleData) => {
        if (editingBundle) {
            await api.put(`/admin/products/${editingBundle._id}`, bundleData);
        } else {
            await api.post('/admin/products/addBundle', bundleData);
        }
        closeModal();
        fetchBundles(currentPage);
    };

    const handleDelete = async (id) => {
        await api.delete(`/admin/products/bundle/${id}`);
        fetchBundles(currentPage);
    };

    return (
        <div className="p-4 space-y-6">
            <div className="flex justify-between items-center">
                <h1 className="text-2xl font-bold">Bundled Product Manager</h1>
                <Button onClick={openCreateModal}>Add Bundled Product</Button>
            </div>

            <div className="overflow-x-auto">
                <table className="w-full table-auto border-collapse">
                    <thead>
                    <tr className="bg-gray-100 text-left">
                        <th className="px-4 py-2">Title</th>
                        <th className="px-4 py-2">Price</th>
                        <th className="px-4 py-2">Category</th>
                        <th className="px-4 py-2 hidden md:table-cell">Products</th>
                        <th className="px-4 py-2">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {bundles.map((bundle) => (
                        <tr key={bundle._id} className="border-b">
                            <td className="px-4 py-2">{bundle.title}</td>
                            <td className="px-4 py-2">${bundle.price.toFixed(2)}</td>
                            <td className="px-4 py-2">{bundle.categorizations[0]?.category}</td>
                            <td className="px-4 py-2 hidden md:table-cell">
                                {bundle.products.map(p => p.sku).join(', ')}
                            </td>
                            <td className="px-4 py-2 space-x-2">
                                <div className="flex gap-2">
                                    <Button onClick={() => openEditModal(bundle)}>Edit</Button>
                                    <Button onClick={() => handleDelete(bundle._id)}>Delete</Button>
                                </div>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

            <div className="flex justify-center gap-2 mt-4">
                <Button onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))} disabled={currentPage === 1}>
                    Previous
                </Button>
                <span className="px-4 py-2">Page {currentPage} of {totalPages}</span>
                <Button onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                        disabled={currentPage === totalPages}>
                    Next
                </Button>
            </div>

            {modalOpen && (
                <BundledProductFormModal
                    open={modalOpen}
                    onClose={closeModal}
                    onSubmit={handleSave}
                    bundle={editingBundle}
                />
            )}
        </div>
    );
}
